module.exports = __webpack_public_path__ + "img/Antique Oak.3a35c53e.jpg";